import React from "react";
import { THEME } from "../theme";

const RISK_COLORS = {
  CRITICAL: THEME.danger,
  HIGH: THEME.warning,
  MODERATE: THEME.accent,
  LOW: THEME.success,
};

export function GlowDot({ color, size = 8, pulse = false }) {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        background: color,
        boxShadow: `0 0 ${size}px ${color}`,
        animation: pulse ? "pulse 2s ease-in-out infinite" : "none",
        flexShrink: 0,
      }}
    />
  );
}

export function Badge({ children, color = THEME.accent, glow = false }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "2px 10px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        color,
        background: glow ? `${color}20` : "transparent",
        border: `1px solid ${color}40`,
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </span>
  );
}

export function RiskBadge({ level }) {
  const color = RISK_COLORS[level] || THEME.textMuted;
  return <Badge color={color} glow>{level}</Badge>;
}

export function ThermalBar({ thresholds, ambientTemp = 12 }) {
  const maxTemp = 30;
  return (
    <div style={{ position: "relative", height: 32, background: THEME.bgPanel, borderRadius: 6, overflow: "hidden", border: `1px solid ${THEME.border}` }}>
      {thresholds.map((t, i) => {
        if (!t.max) return null;
        const prevMax = i > 0 && thresholds[i - 1].max ? thresholds[i - 1].max : 0;
        const left = (prevMax / maxTemp) * 100;
        const width = ((t.max - prevMax) / maxTemp) * 100;
        return (
          <div key={i} title={`${t.label}: ${prevMax}-${t.max}°C`} style={{
            position: "absolute", left: `${left}%`, width: `${width}%`, height: "100%",
            background: `${t.color}50`, borderRight: `1px solid ${t.color}`,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 9, fontWeight: 600, color: t.color, overflow: "hidden", whiteSpace: "nowrap",
          }}>
            {width > 8 && `${t.max}°`}
          </div>
        );
      })}
      {ambientTemp && (
        <div style={{
          position: "absolute", left: `${(ambientTemp / maxTemp) * 100}%`,
          top: 0, bottom: 0, width: 2, background: THEME.accent,
          boxShadow: `0 0 6px ${THEME.accent}`, zIndex: 5,
        }} title={`Ambient: ${ambientTemp}°C`} />
      )}
    </div>
  );
}
